import { CategoryData } from '../../../../types/types';

export const verbes: CategoryData = {
  'Nekk (Être)': { translation: 'Être', translationEn: 'To be', audio: 'Wf-nekk' },
  'Am (Avoir)': { translation: 'Avoir', translationEn: 'To have' },
  'Def (Faire)': { translation: 'Faire', translationEn: 'To do / To make', audio: 'Wf-def' },
  'Dem (Aller)': { translation: 'Aller', translationEn: 'To go', audio: 'Wf-dem' },
  'Ñëw (Venir)': { translation: 'Venir', translationEn: 'To come' },
  'Gis (Voir)': { translation: 'Voir', translationEn: 'To see', audio: 'Wf-gis' },
  'Dégg (Entendre)': { translation: 'Entendre', translationEn: 'To hear', audio: 'Wf-degg' },
  'Lekk (Manger)': { translation: 'Manger', translationEn: 'To eat', audio: 'Wf-lekk' },
  'Naan (Boire)': { translation: 'Boire', translationEn: 'To drink', audio: 'Wf-naan' },
  'Nelaw (Dormir)': { translation: 'Dormir', translationEn: 'To sleep', audio: 'Wf-nelaw' },
  'Wax (Parler)': { translation: 'Parler', translationEn: 'To speak', audio: 'Wf-wax' },
  'Bind (Écrire)': { translation: 'Écrire', translationEn: 'To write' },
  'Jàng (Lire)': { translation: 'Lire', translationEn: 'To read' },
  'Bëgg (Aimer / Vouloir)': { translation: 'Aimer / Vouloir', translationEn: 'To like / To want' },
  'Liggéey (Travailler)': { translation: 'Travailler', translationEn: 'To work', audio: 'Wf-liggeey' },
  'Toog (S\'asseoir)': { translation: 'S\'asseoir', translationEn: 'To sit down', audio: 'Wf-toog' },
  'Taxaw (Se lever / Être debout)': { translation: 'Se lever / Être debout', translationEn: 'To stand up / To be standing', audio: 'Wf-taxaw' },
  'Dox (Marcher)': { translation: 'Marcher', translationEn: 'To walk' },
  'Faj (Guérir)': { translation: 'Guérir', translationEn: 'To heal / To cure', audio: 'Wf-faj' },
  'Joxe (Donner)': { translation: 'Donner', translationEn: 'To give' },
  'Jël (Prendre)': { translation: 'Prendre', translationEn: 'To take' },
  'Xool (Regarder)': { translation: 'Regarder', translationEn: 'To look / To watch', audio: 'Wf-xool' },
  'Xam (Savoir / Connaître)': { translation: 'Savoir / Connaître', translationEn: 'To know' },
  'Jaaxle (Être surpris)': { translation: 'Être surpris', translationEn: 'To be surprised' },
  'Yëngal (Bouger)': { translation: 'Bouger', translationEn: 'To move' },
  'Niroo (Ressembler)': { translation: 'Ressembler', translationEn: 'To resemble', audio: 'Wf-niroo' },
  'Nuyu (Saluer)': { translation: 'Saluer', translationEn: 'To greet', audio: 'Wf-nuyu' },
  'Noppi (Se taire)': { translation: 'Se taire', translationEn: 'To be quiet', audio: 'Wf-noppi' },
  'Waññi (Baisser)': { translation: 'Baisser', translationEn: 'To lower / To reduce' },
  'Seet (Chercher)': { translation: 'Chercher', translationEn: 'To look for / To search', audio: 'Wf-seet' },
  'Laaj (Demander)': { translation: 'Demander', translationEn: 'To ask', audio: 'Wf-laaj' },
  'And (Marcher)': { translation: 'Marcher', translationEn: 'To walk' },
};

export default verbes;
